var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OrderValidation } from './../orderValidation';
import { CurrentOrderService } from './../currentOrder.service';
import { OrderService } from './../order.service';
import { Component } from '@angular/core';
import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MixpanelService } from '../../mixpanel/mixpanel.service';
import { LocalStorageService } from '../../localstorage.service';
var OrderAddressComponent = (function () {
    function OrderAddressComponent(route, orderService, currentOrderService, orderValidation, mixpanelService, localStorage) {
        this.route = route;
        this.orderService = orderService;
        this.currentOrderService = currentOrderService;
        this.orderValidation = orderValidation;
        this.mixpanelService = mixpanelService;
        this.localStorage = localStorage;
    }
    OrderAddressComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.currentOrderService.setMenuVisibility({
            part: true,
            address: true,
            billing: false,
            shipping: false,
            summary: false,
            completed: false
        });
        this.currentOrderService.order.subscribe(function (order) { return _this.order = order; });
        this.currentOrderService.orderType.subscribe(function (orderType) { return _this.orderType = orderType; });
        this.countries = this.route.snapshot.data['countries'];
        console.log(this.order.ShippingAddress.Line);
        this.mixpanelService.trackEvent("address page", this.orderType.lowercaseType);
        if (this.localStorage.getItem('order.contact') != null
            && (this.order.Contact == null || (this.order.Contact.CompanyName == ""
                && this.order.Contact.Email == ""
                && this.order.Contact.FirstName == ""
                && this.order.Contact.LastName == ""
                && this.order.Contact.CompanyName == ""
                && this.order.Contact.Phone == "")))
            this.order.Contact = JSON.parse(this.localStorage.getItem("order.contact"));
        if (this.localStorage.getItem('order.shippingAddress') != null
            && (this.order.ShippingAddress == null || (this.order.ShippingAddress.Line == ""
                && this.order.ShippingAddress.City == ""
                && this.order.ShippingAddress.Country.Name == ""
                && this.order.ShippingAddress.StateProvince == ""
                && this.order.ShippingAddress.PostalCode == "")))
            this.order.ShippingAddress = JSON.parse(this.localStorage.getItem("order.shippingAddress"));
        this.order.IsBillingAddressSame = true;
        // if (
        //   window.localStorage.getItem('order.billingAddress.country') != null
        //   && (
        //     this.order.BillingAddress == null || (
        //       this.order.BillingAddress == ""
        //     )
        //   )
        // ){
        //   this.order.BillingAddress.Country = JSON.parse(window.localStorage.getItem("order.billingAddress.country")) as Country
        // }
        // if (
        //   window.localStorage.getItem('order.billingAddress') != null
        //   && (
        //     this.order.BillingAddress == null || (
        //       this.order.BillingAddress == ""
        //     )
        //   )
        // ){
        //   this.order.BillingAddress = JSON.parse(window.localStorage.getItem("order.billingAddress")) as Address;
        // }
        // if (
        //   window.localStorage.getItem('order.IsBillingAddressSame') != null
        //   && (
        //     this.order.IsBillingAddressSame == null || (
        //       this.order.IsBillingAddressSame == ""
        //     )
        //   )
        // ){
        //   this.order.IsBillingAddressSame = JSON.parse(window.localStorage.getItem("order.IsBillingAddressSame")) as boolean;
        // }
    };
    OrderAddressComponent.prototype.onContinue = function () {
        this.orderService.addMixpanelProfile(this.order, this.orderType.lowercaseType);
    };
    OrderAddressComponent.prototype.checkField = function (event) {
        if (event.target.name == 'country' && event.target.value != '') {
            this.order.ShippingAddress.Country = this.countries.find(function (country) { return country.Id == event.target.value.substr(event.target.value.indexOf(': ') + 2); });
        }
        if (event.target.name == 'Billingcountry' && event.target.value != '') {
            this.order.BillingAddress.Country = this.countries.find(function (country) { return country.Id == event.target.value.substr(event.target.value.indexOf(': ') + 2); });
        }
        if (event.target.name == 'email')
            if (event.target.value != '' && !this.orderValidation.isEmailValid(event.target.value)) {
                event.target.parentElement.className += " is-invalid";
            }
            else {
                event.target.parentElement.className = event.target.parentElement.className.replace(/(?:^|\s)is-invalid(?!\S)/g, '');
            }
        if (event.target.parentElement.className.match(/(?:^|\s)has-error(?!\S)/))
            event.target.parentElement.className = event.target.parentElement.className.replace(/(?:^|\s)has-error(?!\S)/g, '');
        if (event.target.value == '') {
            event.target.parentElement.className += " has-error";
        }
    };
    OrderAddressComponent.prototype.changeShippingCountry = function (countryId) {
        var newCountry = this.countries.find(function (country) { return country.Id == countryId; });
        this.order.ShippingAddress.Country = newCountry;
    };
    OrderAddressComponent.prototype.changeBillingCountry = function (countryId) {
        var newCountry = this.countries.find(function (country) { return country.Id == countryId; });
        this.order.BillingAddress.Country = newCountry;
    };
    OrderAddressComponent.prototype.getCompanyInformationFieldsClass = function () {
        return this.orderValidation.getCompanyInformationFieldsClass();
    };
    OrderAddressComponent.prototype.getShippingAddressFieldsClass = function () {
        return this.orderValidation.getShippingAddressFieldsClass();
    };
    OrderAddressComponent.prototype.getBillingAddressFieldsClass = function () {
        return this.orderValidation.getBillingAddressFieldsClass();
    };
    OrderAddressComponent.prototype.isValid = function () {
        return this.orderValidation.isAddressValid();
    };
    OrderAddressComponent.prototype.getBillingAddress = function () {
        if (this.order.IsBillingAddressSame) {
            this.order.BillingAddress.AccountId = this.order.ShippingAddress.AccountId;
            this.order.BillingAddress.City = this.order.ShippingAddress.City;
            this.order.BillingAddress.Country = this.order.ShippingAddress.Country;
            this.order.BillingAddress.Line = this.order.ShippingAddress.Line;
            this.order.BillingAddress.PostalCode = this.order.ShippingAddress.PostalCode;
            this.order.BillingAddress.StateProvince = this.order.ShippingAddress.StateProvince;
            this.order.BillingAddress.TypeId = this.order.ShippingAddress.TypeId;
        }
    };
    OrderAddressComponent.prototype.resetForm = function () {
        this.order.Contact = {
            FirstName: "",
            LastName: "",
            JobTitle: "",
            Phone: "",
            Email: "",
            AccountId: null,
            CompanyName: ""
        };
        this.order.ShippingAddress = {
            Line: "",
            City: "",
            Country: {
                Id: "",
                Name: "",
                ShortName: ""
            },
            StateProvince: "",
            PostalCode: "",
            TypeId: null,
            AccountId: null
        };
        this.order.BillingAddress = {
            Line: "",
            City: "",
            Country: {
                Id: "",
                Name: "",
                ShortName: ""
            },
            StateProvince: "",
            PostalCode: "",
            TypeId: null,
            AccountId: null
        };
    };
    OrderAddressComponent = __decorate([
        Component({
            selector: 'cx-orderaddress',
            templateUrl: './orderaddress.component.html',
        }),
        __metadata("design:paramtypes", [ActivatedRoute,
            OrderService,
            CurrentOrderService,
            OrderValidation,
            MixpanelService,
            LocalStorageService])
    ], OrderAddressComponent);
    return OrderAddressComponent;
}());
export { OrderAddressComponent };
var OrderAddressGuard = (function () {
    function OrderAddressGuard(orderValidation) {
        this.orderValidation = orderValidation;
    }
    OrderAddressGuard.prototype.canActivate = function () {
        return this.orderValidation.isPartValid();
    };
    OrderAddressGuard = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [OrderValidation])
    ], OrderAddressGuard);
    return OrderAddressGuard;
}());
export { OrderAddressGuard };
//# sourceMappingURL=orderaddress.component.js.map


//////////////////
// WEBPACK FOOTER
// ./src/app/order/wizard/orderaddress.component.js
// module id = 190
// module chunks = 0